import { useTranslation } from 'react-i18next';
import useCreateSelectOptions from './useCreateSelectOptions';
import { DATA_ROOM_ARCHIVE_FILE_TYPE } from 'router/subrouters/DataRoom/subrouters/Settings/pages/SetupPage/components/Snapshots/types';
import { ANALYTICS_EXPORT_TIMEFRAME } from 'router/subrouters/DataRoom/subrouters/Reports/pages/Reports/types';
import { TIMEFRAME_COPY } from 'router/subrouters/DataRoom/subrouters/Reports/pages/Overview/components/DownloadReportModal/components/DownloadReportForm/data';

export default function useAnalyticsExportOptions() {
  const { t } = useTranslation();

  const createSelectOptions = useCreateSelectOptions();

  const fileTypeOptions = createSelectOptions(
    Object.values(DATA_ROOM_ARCHIVE_FILE_TYPE),
  );

  const timeframeOptions = Object.values(ANALYTICS_EXPORT_TIMEFRAME).map(
    (value) => ({
      value,
      label: t(TIMEFRAME_COPY[value]),
    }),
  );

  return { fileTypeOptions, timeframeOptions };
}
